__turbopack_context__.v({
  "alignLeft": "TopDeals-module__0svwLq__alignLeft",
  "cardArrow": "TopDeals-module__0svwLq__cardArrow",
  "cardImage": "TopDeals-module__0svwLq__cardImage",
  "content": "TopDeals-module__0svwLq__content",
  "dealCard": "TopDeals-module__0svwLq__dealCard",
  "dealsSection": "TopDeals-module__0svwLq__dealsSection",
  "header": "TopDeals-module__0svwLq__header",
  "imageWrap": "TopDeals-module__0svwLq__imageWrap",
  "mobileLabel": "TopDeals-module__0svwLq__mobileLabel",
  "overlay": "TopDeals-module__0svwLq__overlay",
  "slickSlide": "TopDeals-module__0svwLq__slickSlide",
  "slickWrap": "TopDeals-module__0svwLq__slickWrap",
  "slider": "TopDeals-module__0svwLq__slider",
  "titleDesktop": "TopDeals-module__0svwLq__titleDesktop",
  "titleMobile": "TopDeals-module__0svwLq__titleMobile",
  "viewAll": "TopDeals-module__0svwLq__viewAll",
});
